import { render, staticRenderFns } from "./type-tree.vue?vue&type=template&id=ff4ff34a"
import script from "./type-tree.vue?vue&type=script&lang=js"
export * from "./type-tree.vue?vue&type=script&lang=js"
import style0 from "./type-tree.vue?vue&type=style&index=0&id=ff4ff34a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports